"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const react_loader_1 = __importDefault(require("react-loader"));
const moment = require("moment");
const Defaults_1 = require("../../common/Defaults");
const hui_1 = require("@mit/hui");
const PeopleStore_1 = require("../../model/PeopleStore");
const CovidNav_1 = require("../../model/CovidNav");
const UploadModalTests = ({ hideModalCallback, show, onClose }) => {
    const [uploadSuccess, setUploadSuccess] = (0, react_1.useState)(undefined);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [uploadFile, setUploadFile] = (0, react_1.useState)({ name: '', file: null });
    const fileUploadedInput = (0, react_1.useRef)(null);
    const handleClose = () => {
        setUploadFile({ name: '', file: null });
        if (fileUploadedInput.current) {
            fileUploadedInput.current.value = '';
        }
        onClose();
    };
    const submitAndClose = () => __awaiter(void 0, void 0, void 0, function* () {
        if (uploadFile.name) {
            setIsLoading(true);
            let uploadResponse = yield MedicalApi_1.default.uploadFile(uploadFile);
            setIsLoading(false);
            if (!uploadResponse.error) {
                setUploadSuccess(true);
            }
            else {
                setUploadSuccess(false);
            }
        }
        else {
        }
    });
    const handleFileUpload = (data) => __awaiter(void 0, void 0, void 0, function* () {
        let csvContent = 'MIT_ID,TEST_DATE,TEST_RESULT,IS_FLU_SHOT,BODY_REGION (OPTIONAL),LOT_NUMBER (OPTIONAL),TEST_BY (OPTIONAL),SOURCE\r\n';
        data.forEach((rowArray) => {
            if (!rowArray[2] || rowArray[2] == null)
                rowArray[2] = '12:00';
            else {
                let time = rowArray[2];
                let momentTime = moment(time, ['h:m a', 'hh:mm a', 'H:m', 'HH:mm']);
                //I apologise to whomever sees this. The backend sometimes converts to UTC. Sometimes it doesn't. 
                //Here is an example of that. On completed tests it converts to UTC, on flushots it doesn't. But the same modal handles both uploads.
                //Again. I'm truly sorry you have to deal with this - I was not given the time to fix it, yet another emergent feature was dreamt up
                if (!window.location.pathname.includes("/completed-tests"))
                    rowArray[2] = momentTime.utc().format('HH:mm');
                else
                    rowArray[2] = momentTime.format('HH:mm');
            }
            rowArray[1] = rowArray[1] + ' ' + rowArray[2];
            rowArray.splice(2, 1);
            if (!window.location.pathname.includes("/completed-tests")) {
                rowArray[2] = 0;
            }
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
        });
        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        let uploadResponse = yield MedicalApi_1.default.uploadFileResults("upload.csv", blob);
        setIsLoading(false);
        if (!uploadResponse.error) {
            setUploadSuccess(true);
            if (CovidNav_1.covidNav.activePage === 'completed-tests') {
                reloadDataCompleted();
            }
            if (CovidNav_1.covidNav.activePage === 'flushots') {
                reloadDataFluShots();
            }
        }
        else {
            setUploadSuccess(false);
        }
    });
    const reloadDataCompleted = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const resultsResponse = yield MedicalApi_1.default.fetchPersonResults(CovidNav_1.covidNav.currentDateString);
        if (resultsResponse.error) {
            //todo: handle error
        }
        else {
            if (resultsResponse.items) {
                PeopleStore_1.peopleStore.setCompletedList(resultsResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const reloadDataFluShots = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const fluShotDetailResponse = yield MedicalApi_1.default.fetchFluShotResults(CovidNav_1.covidNav.currentDateString);
        if (fluShotDetailResponse.error) {
            //todo: handle error
        }
        else {
            if (fluShotDetailResponse.items) {
                PeopleStore_1.peopleStore.setFluShotList(fluShotDetailResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const fieldData = {
        'MIT_ID': { required: true, pattern: { value: /^\d{9,12}$/, message: "Time format" } },
        'TEST_DATE': { required: true, type: "calendar", pattern: { value: /^(\d{4})[\-](\d{2})[\-]\d{2}$/, message: "Date format" } },
        'TEST_TIME': { type: "time", pattern: { value: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]\s?([AaPp][Mm])?$/, message: "Time format" } },
        'TEST_RESULT': { required: window.location.pathname.includes("/completed-tests"), pattern: { value: /^(1|(\-1)|0)$/, message: "Boolean format" } },
        'IS_FLU_SHOT': { required: true, pattern: { value: /^(1|0)$/, message: "Boolean format" } },
        'BODY_REGION': {},
        'LOT_NUMBER': {},
        'TEST_BY': {},
        'SOURCE': {}
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: "Upload Tests", header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Upload Tests File", type: hui_1.TextType.Heading3, icon: "" }), type: hui_1.DrawerType.Right, themedColor: "medical", show: show, onClose: onClose, size: hui_1.DrawerSize.Medium, footer: [], contents: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_loader_1.default, Object.assign({ loaded: !isLoading, options: Object.assign(Object.assign({}, Defaults_1.mediumLoaderOptions), { color: '#000000' }) }, { children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Row, { children: [(0, jsx_runtime_1.jsx)(hui_1.BulkUpload, { themedColor: "medical", autoSave: false, onImport: handleFileUpload, formFields: fieldData, showTemplate: true }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Col, Object.assign({ xs: 12 }, { children: [uploadSuccess === false &&
                                            (0, jsx_runtime_1.jsx)(hui_1.Alert, { type: "warning", text: `An error occurred uploading the file. If the problem persists please contact ${Defaults_1.CONTACT_SUPPORT_LINK}.` }), uploadSuccess === true && (0, jsx_runtime_1.jsx)(hui_1.Alert, { type: "success", text: "The file has been uploaded successfully." })] }))] }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "text-center" }, { children: [uploadSuccess &&
                                (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "p-3" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: handleClose, state: isLoading ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, text: "Done" }) })), uploadSuccess !== true &&
                                (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "p-3" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: handleClose, state: isLoading ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, text: "Cancel" }) }))] }))] }) }) }));
};
exports.default = UploadModalTests;
